<template>
  <div class="h-screen flex w-full bg-img bg-custom-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="px-8 py-4" style="border-bottom: 1px solid #ccc; background-color: #EEE;">
                <h3 style="text-align: center; font-weight: bold;">LOGIN</h3>
              </div>
              <div class="px-8 py-4">
                <vs-input v-validate="'required'" data-vv-as="Username" name="username" icon="icon icon-user" icon-pack="feather" label-placeholder="Username" v-model="username" class="w-full no-icon-border" />
                <span class="text-danger text-sm">{{ errors.first('username') }}</span>
                <vs-input v-validate="'required'" data-vv-as="Password" type="password" name="password" icon="icon icon-lock" icon-pack="feather" label-placeholder="Password" v-model="password" class="w-full mt-8 no-icon-border" />
                <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                <!--<div class="flex flex-wrap justify-between my-8">
                  <vs-checkbox v-model="remember_me" class="mb-3">Remember Me</vs-checkbox>
                </div>-->
                <div class="my-5">
                  <vs-button color="success" class="vs-xs-12 float-right mb-5" @click="login">Login</vs-button>
                  <!--<vs-button class="vs-xs-12 float-right mb-5" :disabled="!validateForm" @click="login">เข้าสู่ระบบ</vs-button>-->
                  <!--<vs-button type="border" class="vs-xs-12 mb-5" to="/register">สมัครสมาชิก</vs-button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import auth from "@/services/authService"
import { Validator } from 'vee-validate'

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data() {
    return {
      username: '',
      email: '',
      password: '',
      remember_me: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.username != '' && this.password != '';
    },
  },
  methods: {
    login() {

      this.$validator.validate().then(valid => {

        if (valid) {
          this.email = this.username+'@'+process.env.VUE_APP_DOMAIN
          if(process.env.VUE_APP_ADMIN_AUTH.split(',').includes(this.email)) {

            firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
            .then((data) => {

              console.log('success', data.user.uid)

              firebase
              .auth()
              .currentUser
              .getIdToken(true)
              .then(async (idToken)=>{

                this.$vs.notify({
                  title: 'เข้าสู่ระบบสำเร็จ',
                  text: 'กรุณารอซักครู่...',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                });

                await auth.saveLogin({
                  accessToken: idToken,
                  role: 'Admin'
                });

                setTimeout(()=>{
                  //location.reload(true)
                  this.$router.push({
                    name: 'AdminResults'
                  })
                }, 1000)

              })

            })
            .catch(err => {
              //this.error = err.message;
              //console.log('error', err)
              this.$vs.notify({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            })

          }else{
            this.$vs.notify({
              title: 'เข้าสู่ระบบไม่สำเร็จ',
              text: 'ข้อมูลไม่ถูกต้อง',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }

        }

      })

    }

  },
  mounted() {
    Validator.localize('th', {
      custom: {
        username: {
          required: 'Username is required'
        }
      }
    });
  }
}

</script>
<style lang="scss">
#page-login {
  &.bg-custom-img {
    background-image: url('../../assets/theme/bg.jpg');
  }
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285F4;
    }

    .bg-github {
      background-color: #333;
    }
  }

  .vs-input--placeholder {
    font-size: 1rem;
  }

  .isFocus {
    .vs-input--placeholder.normal {
      padding: 0.2rem !important;
      padding-left: 3rem !important;
    }
  }
}

</style>
